import { useCallback, type MutableRefObject } from "react";

interface UseSessionLiveSignalLifecycleInput {
  initialLoadCompletedAtRef: MutableRefObject<number | null>;
  userAttachmentsProductIdRef: MutableRefObject<string | null>;
  resetLiveFlashes: () => void;
  resetMemberActivity: () => void;
  resetProductDetailObserver: () => void;
  resetReflectionObserver: () => void;
  cleanupLiveFlashTimers: () => void;
  cleanupMemberActivityTimers: () => void;
}

interface SessionLiveSignalLifecycle {
  resetLiveSignals: () => void;
  cleanupLiveSignalTimers: () => void;
}

export function useSessionLiveSignalLifecycle({
  initialLoadCompletedAtRef,
  userAttachmentsProductIdRef,
  resetLiveFlashes,
  resetMemberActivity,
  resetProductDetailObserver,
  resetReflectionObserver,
  cleanupLiveFlashTimers,
  cleanupMemberActivityTimers,
}: UseSessionLiveSignalLifecycleInput): SessionLiveSignalLifecycle {
  const resetLiveSignals = useCallback((): void => {
    initialLoadCompletedAtRef.current = null;
    userAttachmentsProductIdRef.current = null;
    resetReflectionObserver();
    resetProductDetailObserver();
    resetLiveFlashes();
    resetMemberActivity();
  }, [
    initialLoadCompletedAtRef,
    resetLiveFlashes,
    resetMemberActivity,
    resetProductDetailObserver,
    resetReflectionObserver,
    userAttachmentsProductIdRef,
  ]);

  const cleanupLiveSignalTimers = useCallback((): void => {
    cleanupLiveFlashTimers();
    cleanupMemberActivityTimers();
  }, [cleanupLiveFlashTimers, cleanupMemberActivityTimers]);

  return { resetLiveSignals, cleanupLiveSignalTimers };
}
